import i18n from "@/i18n";

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const HOUR_MINUTES = 60;
const DAY_MINUTES = 24 * HOUR_MINUTES;

type TimeUnit = "days" | "hours" | "minutes";
type TimeUnitKey = `goals.time.${TimeUnit}`;

const formatUnit = (unit: TimeUnit, count: number) => {
  const key: TimeUnitKey = `goals.time.${unit}`;

  return i18n.t(key, { count });
};

export const formatGoalRewardAmount = (amount: number) =>
  `${new Intl.NumberFormat("ru-RU").format(amount)} ₽`;

export const formatTimeLeft = (milliseconds: number) => {
  const totalMinutes = Math.max(0, Math.ceil(milliseconds / MINUTE_MS));

  if (totalMinutes > DAY_MINUTES) {
    const days = Math.floor(totalMinutes / DAY_MINUTES);
    const hours = Math.floor(
      (totalMinutes - days * DAY_MINUTES) / HOUR_MINUTES
    );
    const parts = [formatUnit("days", days)];

    if (hours > 0) {
      parts.push(formatUnit("hours", hours));
    }

    return parts.join(" ");
  }

  const hours = Math.floor(totalMinutes / HOUR_MINUTES);
  const minutes = totalMinutes % HOUR_MINUTES;
  const parts: string[] = [];

  if (hours > 0) {
    parts.push(formatUnit("hours", hours));
  }

  if (minutes > 0 || parts.length === 0) {
    parts.push(formatUnit("minutes", minutes));
  }

  return parts.join(" ");
};

export const formatWinnerReceivedDate = (
  receivedDate: string,
  now = Date.now()
) => {
  const timestamp = new Date(receivedDate).getTime();

  if (Number.isNaN(timestamp)) {
    return receivedDate;
  }

  const elapsedMs = Math.max(now - timestamp, 0);

  if (elapsedMs < MINUTE_MS) {
    return "только что";
  }

  if (elapsedMs < HOUR_MS) {
    return `${Math.floor(elapsedMs / MINUTE_MS)} мин. назад`;
  }

  if (elapsedMs < DAY_MS) {
    return `${Math.floor(elapsedMs / HOUR_MS)} ч. назад`;
  }

  return `${Math.floor(elapsedMs / DAY_MS)} д. назад`;
};
